const convertDateToShamsi = (dateString) => {
    const dateObject = new Date(dateString);
    const options = {year: 'numeric', month: 'long', day: 'numeric'};
    return dateObject.toLocaleDateString('fa-IR', options);
}

export default convertDateToShamsi;